import { ReduxDrawerType, SET_DRAWER } from '../store/drawer';

export function setDrawer(drawer: ReduxDrawerType) {
  return {
    type: SET_DRAWER,
    payload: drawer,
  };
}
